// @ts-nocheck
import React from 'react';

const Section1 = ({ photo1, photo2 }) => {
  return (
    <>
      <section className="">
        <div className="relative flex">
          <img className="object-cover w-1/2 p-2 rounded-xl" src={photo1} alt="" />
          <img className="object-cover w-1/2 p-2 rounded-xl" src={photo2} alt="" />
        </div>
      </section>
    </>
  );
};

export default Section1;
